import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import "web/script/components/auto-complete";
import "web/script/components/category-options";
import "web/script/components/saved-search-brand-search";

const productTypeOptionsComponentName = "product-type-options";
const categoryOptionsComponentName = "category-options";

const selectors = {
    FOCUSED_ELEMENT_CLASS_NAME: "wizard__element--focused",
    GENDER_INPUT: "[name='gender']",
    PRODUCT_TYPE_CHECKED_INPUT: "input[name='product_type']:checked",
    CATEGORY_CHECKED_INPUT: "input[name='category']:checked",
    CATEGORY_OPTION_INPUT: "input[name='categories_type']:checked",
    ITEMS_OPTION_INPUT: "input[name='items_type']:checked",
    DESIGNER_OPTION_INPUT: "input[name='designers_type']:checked",
    CATEGORY_OPTION: ".categories_type",
    DESIGNER_OPTION: ".designers_type",
    ITEMS_OPTION: ".items_type",
    BRAND_SEARCH: ".auto-complete__profile-name",
    SUBMIT_BUTTON: ".wizard__form__submit-button",
    NAME_INPUT: "input[name='name']",
};

export default baustein.register("saved-search-creator", {
    setupEvents(add) {
        // listening to change instead of click gender switch input button because in ios,
        // you cannot click a div inside a label. The trick to fix that is by adding
        // pointer-events: none which doesn't trigger the click event of the button.
        add("brandChanged", this._brandChanged);
        add("openedDropDown", this._closeOtherDropDown);
        add("openedDropDown", this._elementFocused);
        add("productTypeChanged", this._productTypeChanged);
        add("categoryChanged", this._categoryChanged);
        add("brandSearchInputClicked", this._elementFocused);
        add("click", selectors.NAME_INPUT, this._send_name_analytics);
        add("click", selectors.CATEGORY_OPTION, this.toggleCategoryType);
        add("change", selectors.CATEGORY_OPTION, this.toggleCategoryType);
        add("click", selectors.DESIGNER_OPTION, this.toggleDesignerType);
        add("change", selectors.DESIGNER_OPTION, this.toggleDesignerType);
        add("click", selectors.ITEMS_OPTION, this.toggleItemsType);
        add("change", selectors.ITEMS_OPTION, this.toggleItemsType);
        add("click", selectors.SUBMIT_BUTTON, this._handleSubmit);
    },

    init() {
        if (this.el.querySelector("input[name='id']")) {
            this.selectedProductType = null;
            this.selectedCategory = null;
            this.selectedBrand = null;
            this.savedLystFilterId = this.el.querySelector("input[name='id']").value;
            this.optionCategory = this.el.querySelector(selectors.CATEGORY_OPTION_INPUT).value;
            this.optionItems = this.el.querySelector(selectors.ITEMS_OPTION_INPUT).value;
            this.optionDesigner = this.el.querySelector(selectors.DESIGNER_OPTION_INPUT).value;
            this.name = this.el.querySelector("input[name='name']").value;
            if (this.optionCategory === "select_category") {
                this.selectedProductType = this.el.querySelector(
                    selectors.PRODUCT_TYPE_CHECKED_INPUT
                ).value;
                this.selectedCategory = this.el.querySelector(
                    selectors.CATEGORY_CHECKED_INPUT
                ).value;
            }
            if (this.el.querySelector(selectors.BRAND_SEARCH)) {
                this.selectedBrand = this.el.querySelector(selectors.BRAND_SEARCH).textContent;
            }
        }
    },

    async toggleItemsType(event) {
        const itemsType = event.target.value;
        if (!itemsType) {
            return;
        }
        const inputItems = Array.from(this.el.querySelectorAll("input[name='items_type']"));
        inputItems.forEach((item) => {
            if (itemsType === item.value) {
                item.checked = true;
            } else {
                item.checked = false;
            }
        });

        const optionItems = Array.from(
            this.el.querySelectorAll("select[name='items_type'] option")
        );
        optionItems.forEach((item) => {
            if (itemsType === item.value) {
                item.selected = true;
            } else {
                item.selected = false;
            }
        });
        await analytics.event(itemsType, "clicked", "types of items you are looking for");
    },

    async toggleCategoryType(event) {
        const categoryType = event.target.value;
        if (!categoryType) {
            return;
        }

        const inputItems = Array.from(this.el.querySelectorAll("input[name='categories_type']"));
        inputItems.forEach((item) => {
            if (categoryType === item.value) {
                item.checked = true;
            } else {
                item.checked = false;
            }
        });

        const optionItems = Array.from(
            this.el.querySelectorAll("select[name='categories_type'] option")
        );
        optionItems.forEach((item) => {
            if (categoryType === item.value) {
                item.selected = true;
            } else {
                item.selected = false;
            }
        });

        const section = this.el.querySelector(".wizard__category-type");
        const line = this.el.querySelector(".wizard__line");
        const items = Array.from(this.el.querySelectorAll(".category-dropdown"));
        items.forEach((item) => {
            if (categoryType === "select_category") {
                item.classList.remove("hidden");
                section.classList.remove("wizard__pb-spacer--desktop");
                section.classList.remove("mb40");
                section.classList.remove("mb20");
                line.classList.remove("hidden");
            } else if (categoryType === "everything") {
                section.classList.add("wizard__pb-spacer--desktop");
                section.classList.add("mb40");
                section.classList.add("mb20");
                item.classList.add("hidden");
                line.classList.add("hidden");
            }
        });

        const category = categoryType === "select_category" ? "select category" : "everything";
        await analytics.event(category, "clicked", "categories section");
    },

    async toggleDesignerType(event) {
        const designerType = event.target.value;
        if (!designerType) {
            return;
        }

        const inputItems = Array.from(this.el.querySelectorAll("input[name='designers_type']"));
        inputItems.forEach((item) => {
            if (designerType === item.value) {
                item.checked = true;
            } else {
                item.checked = false;
            }
        });

        const optionItems = Array.from(
            this.el.querySelectorAll("select[name='designers_type'] option")
        );
        optionItems.forEach((item) => {
            if (designerType === item.value) {
                item.selected = true;
            } else {
                item.selected = false;
            }
        });

        const followed = this.el.querySelector(".followed");
        const brandSearch = this.el.querySelector(".brand-search");
        if (designerType === "single") {
            followed.classList.add("hidden");
            brandSearch.classList.remove("hidden");
        } else if (designerType === "followed") {
            followed.classList.remove("hidden");
            brandSearch.classList.add("hidden");
            const brandSearchComponent = this.findComponent("saved-search-brand-search");
            brandSearchComponent.clearBrands();
        }

        const category = designerType === "single" ? "single designer" : "followed designers";
        await analytics.event(category, "clicked", "who do you want to receive updates from");
    },

    _closeOtherDropDown(event) {
        const productTypeOptionsComponent = this.findComponent(productTypeOptionsComponentName);
        const categoryOptionsComponent = this.findComponent(categoryOptionsComponentName);
        const otherComponent =
            event.target === categoryOptionsComponent
                ? productTypeOptionsComponent
                : categoryOptionsComponent;
        otherComponent.closeDropDown();
    },

    closeDropDownsAndBlurElements() {
        const productTypeOptionsComponent = this.findComponent(productTypeOptionsComponentName);
        const categoryOptionsComponent = this.findComponent(categoryOptionsComponentName);
        productTypeOptionsComponent.closeDropDown();
        categoryOptionsComponent.closeDropDown();
        this._blurElements();
    },

    _updateTaxonomyOptions(selectedGender, selectedProductType) {
        const taxonomyMap = this.options.taxonomyMap;

        const productTypeOptionsComponent = this.findComponent(productTypeOptionsComponentName);
        const categoryOptionsComponent = this.findComponent(categoryOptionsComponentName);

        productTypeOptionsComponent.updateProductTypeOptions(
            taxonomyMap,
            selectedGender,
            selectedProductType
        );
        categoryOptionsComponent.updateCategoryOptions(
            taxonomyMap,
            selectedGender,
            selectedProductType
        );
    },

    async _productTypeChanged(event) {
        const selectedGender = this._getActiveGender();
        this._updateTaxonomyOptions(selectedGender, event.selectedProductType);

        this._closeOverlay();
    },

    async _categoryChanged(event) {
        const taxonomyMap = this.options.taxonomyMap;
        const selectedGender = this._getActiveGender();
        const selectedProductType = this.el.querySelector(
            selectors.PRODUCT_TYPE_CHECKED_INPUT
        ).value;

        const categoryOptionsComponent = this.findComponent(categoryOptionsComponentName);
        categoryOptionsComponent.updateCategoryOptions(
            taxonomyMap,
            selectedGender,
            selectedProductType,
            event.selectedCategory
        );

        this._closeOverlay();
    },

    async _brandChanged() {
        const selectedBrand = this.el.querySelector(selectors.BRAND_SEARCH).textContent;
        this._closeOverlay();
        this._blurElements();
        await analytics.event("designer", "searched", selectedBrand);
    },

    _closeOverlay() {
        this.emit("closeLystMatte");
    },

    _blurElements() {
        this.el.querySelectorAll(`.${selectors.FOCUSED_ELEMENT_CLASS_NAME}`).forEach((element) => {
            element.classList.remove(selectors.FOCUSED_ELEMENT_CLASS_NAME);
        });
    },
    /**
     * Gets the current active Gender constant "M" or "F"
     *
     * @returns {string}
     */
    _getActiveGender() {
        return document.querySelector(selectors.GENDER_INPUT).textContent;
    },

    _elementFocused(event) {
        this.emit("openLystMatteWithScroll");
        let element = event.target.el;
        element.classList.add(selectors.FOCUSED_ELEMENT_CLASS_NAME);
    },

    async _send_name_analytics() {
        await analytics.event("name", "clicked");
    },

    async _send_edit_events_to_analytics() {
        const name = this.el.querySelector("input[name='name']").value;
        if (name != this.name) {
            await analytics.event("name", "edited", name);
        }

        if (this.el.querySelector(selectors.BRAND_SEARCH)) {
            const brand = this.el.querySelector(selectors.BRAND_SEARCH).textContent;
            if (this.selectedBrand && brand != this.selectedBrand) {
                await analytics.event("designer", "edited", brand);
            }
        }
        const optionCategory = this.el.querySelector(selectors.CATEGORY_OPTION_INPUT).value;
        const optionItems = this.el.querySelector(selectors.ITEMS_OPTION_INPUT).value;
        const optionDesigner = this.el.querySelector(selectors.DESIGNER_OPTION_INPUT).value;

        if (optionCategory != this.optionCategory) {
            await analytics.event(optionCategory, "edited");
        }

        if (optionItems != this.optionItems) {
            await analytics.event(optionItems, "edited");
        }

        if (optionDesigner != this.optionDesigner) {
            await analytics.event(optionDesigner, "edited");
        }

        if (optionCategory === "select_category") {
            const selectedProductType = this.el.querySelector(
                selectors.PRODUCT_TYPE_CHECKED_INPUT
            ).value;
            const selectedCategory = this.el.querySelector(selectors.CATEGORY_CHECKED_INPUT).value;
            if (selectedProductType != this.selectedProductType) {
                await analytics.event("product type", "edited", selectedProductType);
            }

            if (selectedCategory && selectedCategory != this.selectedCategory) {
                await analytics.event("category type", "edited", selectedCategory);
            }
        }

        await analytics.event("save", "clicked");
    },

    async _send_create_events_to_analytics() {
        const selectedBrand = this.el.querySelector(selectors.BRAND_SEARCH);
        if (selectedBrand) {
            await analytics.event("designer", "selected", selectedBrand.textContent);
        }
        const optionCategory = this.el.querySelector(selectors.CATEGORY_OPTION_INPUT).value;
        const optionItems = this.el.querySelector(selectors.ITEMS_OPTION_INPUT).value;
        const optionDesigner = this.el.querySelector(selectors.DESIGNER_OPTION_INPUT).value;

        await analytics.event(optionCategory, "selected");
        await analytics.event(optionItems, "selected");
        await analytics.event(optionDesigner, "selected");

        if (optionCategory === "select_category") {
            const selectedProductType = this.el.querySelector(
                selectors.PRODUCT_TYPE_CHECKED_INPUT
            ).value;
            const selectedCategory = this.el.querySelector(selectors.CATEGORY_CHECKED_INPUT).value;
            await analytics.event("product type", "selected", selectedProductType);
            if (selectedCategory) {
                await analytics.event("category type", "selected", selectedCategory);
            }
        }
        await analytics.event("create a new search", "clicked");
    },

    async _handleSubmit() {
        if (this.savedLystFilterId) {
            this._send_edit_events_to_analytics();
        } else {
            this._send_create_events_to_analytics();
        }
    },
});
